// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AssessmentsRouteImport } from './routes/assessments'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as B2bLeadMagnetsRouteImport } from './routes/b2b-lead-magnets'
import { Route as CustomAppBuildsRouteImport } from './routes/custom-app-builds'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as EulaRouteImport } from './routes/eula'
import { Route as EventLandingPagesRouteImport } from './routes/event-landing-pages'
import { Route as IdeaGeneratorRouteImport } from './routes/idea-generator'
import { Route as LeadGenerationCalculatorRouteImport } from './routes/lead-generation-calculator'
import { Route as LeadGenerationToolsRouteImport } from './routes/lead-generation-tools'
import { Route as LinkedinAdvertisingRouteImport } from './routes/linkedin-advertising'
import { Route as PhpVulnerabilitySquarespaceRouteImport } from './routes/php-vulnerability-squarespace'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as SeoAiVisibilityRouteImport } from './routes/seo-ai-visibility'
import { Route as SquarespaceMigrationsRouteImport } from './routes/squarespace-migrations'
import { Route as SquarespaceWebsitesRouteImport } from './routes/squarespace-websites'
import { Route as VisualizersRouteImport } from './routes/visualizers'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AssessmentsRoute = AssessmentsRouteImport.update({
            id: '/assessments',path: '/assessments',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const B2bLeadMagnetsRoute = B2bLeadMagnetsRouteImport.update({
            id: '/b2b-lead-magnets',path: '/b2b-lead-magnets',getParentRoute: () => rootRouteImport
          })
const CustomAppBuildsRoute = CustomAppBuildsRouteImport.update({
            id: '/custom-app-builds',path: '/custom-app-builds',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const EulaRoute = EulaRouteImport.update({
            id: '/eula',path: '/eula',getParentRoute: () => rootRouteImport
          })
const EventLandingPagesRoute = EventLandingPagesRouteImport.update({
            id: '/event-landing-pages',path: '/event-landing-pages',getParentRoute: () => rootRouteImport
          })
const IdeaGeneratorRoute = IdeaGeneratorRouteImport.update({
            id: '/idea-generator',path: '/idea-generator',getParentRoute: () => rootRouteImport
          })
const LeadGenerationCalculatorRoute = LeadGenerationCalculatorRouteImport.update({
            id: '/lead-generation-calculator',path: '/lead-generation-calculator',getParentRoute: () => rootRouteImport
          })
const LeadGenerationToolsRoute = LeadGenerationToolsRouteImport.update({
            id: '/lead-generation-tools',path: '/lead-generation-tools',getParentRoute: () => rootRouteImport
          })
const LinkedinAdvertisingRoute = LinkedinAdvertisingRouteImport.update({
            id: '/linkedin-advertising',path: '/linkedin-advertising',getParentRoute: () => rootRouteImport
          })
const PhpVulnerabilitySquarespaceRoute = PhpVulnerabilitySquarespaceRouteImport.update({
            id: '/php-vulnerability-squarespace',path: '/php-vulnerability-squarespace',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const SeoAiVisibilityRoute = SeoAiVisibilityRouteImport.update({
            id: '/seo-ai-visibility',path: '/seo-ai-visibility',getParentRoute: () => rootRouteImport
          })
const SquarespaceMigrationsRoute = SquarespaceMigrationsRouteImport.update({
            id: '/squarespace-migrations',path: '/squarespace-migrations',getParentRoute: () => rootRouteImport
          })
const SquarespaceWebsitesRoute = SquarespaceWebsitesRouteImport.update({
            id: '/squarespace-websites',path: '/squarespace-websites',getParentRoute: () => rootRouteImport
          })
const VisualizersRoute = VisualizersRouteImport.update({
            id: '/visualizers',path: '/visualizers',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AssessmentsRoute: AssessmentsRoute,AuthRoute: AuthRoute,B2bLeadMagnetsRoute: B2bLeadMagnetsRoute,CustomAppBuildsRoute: CustomAppBuildsRoute,DashboardRoute: DashboardRoute,EulaRoute: EulaRoute,EventLandingPagesRoute: EventLandingPagesRoute,IdeaGeneratorRoute: IdeaGeneratorRoute,LeadGenerationCalculatorRoute: LeadGenerationCalculatorRoute,LeadGenerationToolsRoute: LeadGenerationToolsRoute,LinkedinAdvertisingRoute: LinkedinAdvertisingRoute,PhpVulnerabilitySquarespaceRoute: PhpVulnerabilitySquarespaceRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,SeoAiVisibilityRoute: SeoAiVisibilityRoute,SquarespaceMigrationsRoute: SquarespaceMigrationsRoute,SquarespaceWebsitesRoute: SquarespaceWebsitesRoute,VisualizersRoute: VisualizersRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)